// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Currency from "../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function getFareVm(fare, fare_type, cashback, currency) {
  return {
          fare_type: fare_type,
          base_fare: Currency.toCurrencyString(fare.base_fare, currency),
          waiting_time: fare.waiting_time.toString() + " mins",
          travel_distance: fare.travel_distance.toFixed(2) + " kms",
          distance_charge: Currency.toCurrencyString(fare.distance_charge, currency),
          travel_duration: fare.travel_duration.toFixed(2) + " mins",
          time_charge: Currency.toCurrencyString(Currency.add(fare.waiting_charge, fare.travel_duration_charge), currency),
          demand_surcharge: Currency.toCurrencyString(fare.flat_surge_amount, currency),
          pickup_extra_charge: Currency.toCurrencyString(fare.pickup_extra_charge, currency),
          drop_extra_charge: Currency.toCurrencyString(fare.drop_extra_charge, currency),
          helper_charges: Currency.toCurrencyString(fare.helper_charge, currency),
          helper_labour: Currency.toCurrencyString(fare.helper_plus_labour_charge, currency),
          waypoints: String(fare.waypoints),
          waypoint_charge: Currency.toCurrencyString(fare.waypoint_charge, currency),
          road_tax: Currency.toCurrencyString(fare.road_tax, currency),
          toll: Currency.toCurrencyString(fare.toll, currency),
          vat: Belt_Option.mapWithDefault(fare.vat, "N/A", (function (vat) {
                  return Currency.toCurrencyString(vat, currency);
                })),
          up_entry_charge: Currency.toCurrencyString(fare.convenience_charge, currency),
          environmental_tax: Currency.toCurrencyString(fare.environmental_tax, currency),
          travel_fare: Currency.toCurrencyString(fare.partner_trip_fare, currency),
          loading_time: fare.loading_time.toString(),
          unloading_time: fare.unloading_time.toString(),
          porter_gold_savings: Currency.toCurrencyString(fare.porter_bearing_total_discount, currency),
          subscription_savings: Currency.toCurrencyString(fare.subscription_discount, currency),
          referral_discount: Currency.toCurrencyString(fare.referral_discount, currency),
          coupon_discount: Currency.toCurrencyString(fare.coupon_discount, currency),
          cashback: Belt_Option.mapWithDefault(cashback, "N/A", (function (s) {
                  return Currency.toCurrencyString(s, currency);
                })),
          fare: Currency.toCurrencyString(fare.trip_fare, currency),
          preTripRoundOff: Belt_Option.mapWithDefault(fare.pre_trip_fare_round_off, "N/A", (function (v) {
                  return Currency.toCurrencyString(v, currency);
                })),
          courier_fee: Belt_Option.mapWithDefault(fare.courier_fee, "N/A", (function (courier_fee) {
                  return Currency.toCurrencyString(courier_fee, currency);
                }))
        };
}

function raiseError(key) {
  return Curry._1(ErrorUtils$Catalyst.raiseError("OrderFareTableVm.re", key + " missing for completed order", undefined), undefined);
}

function getVm(order_fare, order_details, currency) {
  switch (order_details.TAG | 0) {
    case /* Ended */3 :
    case /* CancelledEnded */8 :
        break;
    default:
      return {
              hd: getFareVm(order_fare.estimated, "Fixed", undefined, currency),
              tl: /* [] */0
            };
  }
  var x = order_fare.default_fare;
  var x$1 = order_fare.customer;
  return List.fold_left((function (lst, fare) {
                if (fare !== undefined) {
                  return List.append(lst, {
                              hd: fare,
                              tl: /* [] */0
                            });
                } else {
                  return lst;
                }
              }), /* [] */0, {
              hd: getFareVm(order_fare.estimated, "Fixed", undefined, currency),
              tl: {
                hd: x !== undefined ? getFareVm(x, "Actual", undefined, currency) : raiseError("default_fare"),
                tl: {
                  hd: x$1 !== undefined ? getFareVm(x$1.fare, "Current", Caml_option.some(x$1.payment.online_payment.breakup_details.cashback), currency) : raiseError("customer"),
                  tl: {
                    hd: Belt_Option.mapWithDefault(order_fare.vendor, undefined, (function (x) {
                            return getFareVm(x, "Vendor", undefined, currency);
                          })),
                    tl: {
                      hd: Belt_Option.mapWithDefault(order_fare.fixed_fallback, undefined, (function (x) {
                              return getFareVm(x, "New Fixed", undefined, currency);
                            })),
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

export {
  getFareVm ,
  raiseError ,
  getVm ,
  
}
/* No side effect */
